export const PermissionScope = Object.freeze({
  ACCOUNTS: 'accounts',
  BOOKING: 'booking',
  TIMESHEETS: 'timesheets',
  REPLACE_ME: 'replaceMe',
  PENDING_BOOKING: 'pendingBooking',
})
